import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    Container,
    Grid,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as articleActions from '../../redux/actions/articles';
import Header from 'src/components/header-external';
import Footer from 'src/components/footer-external';
import CustomizedSnackbars from 'src/components/material-snackbars';
import LogoMarca from 'src/images/new-logo2-cmtech.png';
import { browserHistory } from 'src/helpers/history';
import NewsSectionMainContent from './components/news-section-main-content';
import Modal from 'src/components/modal-external/modal-principal';
import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";
import CommonSearchExternal from 'src/components/client-portal/common-search-external';
import CommonBackButtonExternal from 'src/components/client-portal/common-back-button-external';
import CommonPaginateSkeleton from 'src/components/client-portal/common-paginate-skeleton';

function NewsSectionPage(props) {
    const { classes, intl } = props;
    const { sectionId } = useParams();

    const [articles, setArticles] = useState([]);
    const [sectionInfo, setSectionInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hirerId, setHirerId] = useState(null);
    const [clientportal, setClientPortal] = useState({});
    const [logoimagesrc, setLogoImageSrc] = useState('');
    const [searchvalue, setSearchValue] = useState('');
    const [openNotification, setOpenNotification] = useState(false);
    const [notificationVariant, setNotificationVariant] = useState('error');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [parentsSectionsInfo, setParentsSectionsInfo] = useState([]);
    const [calledServiceSettingsList, setCalledServiceSettingsList] = useState([]);
    const [mainimagesrc, setMainImageSrc] = useState("");
    const [createCalledDialogOpen, setCreateCalledDialogOpen] = useState(false);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api) {
            console.error("Falha ao carregar o serviço de Api.");
            setLoading(false);
            return;
        }

        const getHirerId = async () => {
            try {
                const result = await Api.get(`/configs/cancreateclientusersexternal`);
                if (result.data.success && result.data.data?.hirerid) {
                    setHirerId(result.data.data.hirerid);
                } else {
                    console.error(" Não foi possível obter hirerId");
                    setLoading(false);
                }
            } catch (error) {
                console.error(" Erro ao buscar hirerId:", error);
                setLoading(false);
                if (Api.kickoff) Api.kickoff(error);
            }
        };

        getHirerId();
    }, []);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api) {
            console.error("Falha ao carregar o serviço de Api.");
            setLoading(false);
            return;
        }

        const loadData = async () => {
            if (!sectionId || !hirerId) {
                return;
            }

            setLoading(true);

            try {
                const sectionsResponse = await Api.get(`articles-section/parents/${sectionId}`);
                if (sectionsResponse.data.success) {
                    const data = sectionsResponse.data.data || [];

                    const currentSection = data.find(section => section.id === parseInt(sectionId));

                    setSectionInfo(currentSection || null);
                    setParentsSectionsInfo(data);
                }

                const articlesResponse = await Api.get(
                    `articles/paginatebyarticlesection/external/${sectionId}`,
                    {
                        params: {
                            hirerid: hirerId,
                            page: 1,
                        }
                    }
                );

                if (articlesResponse.data.success) {
                    const articlesData = articlesResponse.data.data || [];
                    setArticles(articlesData);
                } else {
                    setArticles([]);
                }

            } catch (error) {
                console.error(" Erro ao carregar dados:", error);
                setArticles([]);
                if (Api.kickoff) Api.kickoff(error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [sectionId, hirerId]);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api || !hirerId) return;

        const getClientPortal = async () => {
            try {
                const result = await Api.get(`/clientportal/external/hirer/${hirerId}`);
                if (result.data && result.data.success) {
                    const data = result.data.data;

                    setClientPortal(data);

                    if (data.logoimage) {
                        const result = await getFile(data.logoimage);
                        if (result) {
                            setLogoImageSrc(result);
                        }
                    } else {
                        const image = Api.getLoginImage();
                        if (image) {
                            const result = await getFile(image);
                            if (result) {
                                setLogoImageSrc(result);
                            }
                        } else {
                            setLogoImageSrc(LogoMarca);
                        }
                    }

                    if (data.mainimage) {
                        const result = await getFile(data.mainimage);
                        if (result) {
                            setMainImageSrc(result);
                        }
                    }
                }
            } catch (error) {
                console.error(" Erro ao buscar portal do cliente:", error);
            }
        };

        getClientPortal();
    }, [hirerId]);

    const getFile = async (image) => {
        let result = null;
        try {
            let xhttpImage = new XMLHttpRequest();
            xhttpImage.open("GET", `${image.anonymoustoken}`, false);
            xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*');
            xhttpImage.send();
            let ImageData = JSON.parse(xhttpImage.responseText);
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                result = ImageData.data;
            }
        } catch (e) {
            console.error("Erro ao carregar imagem:", e);
            return result;
        }
        return result;
    };

    const handleBack = () => {
        if (props.history.length > 1) {
            browserHistory.goBack();
        } else {
            props.history.push(`/${props.match.params.lang}/client-portal-external`);
        }
    };

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const searchArticle = () => {
        props.addCurrentSearch(searchvalue, "text")
        props.history.push(`/${props.match.params.lang}/article-list-external`);
    };

    const closeNotification = () => {
        setOpenNotification(false);
    };

    const openCreateCalledDialog = (calledServiceSettingsList) => {
        setCreateCalledDialogOpen(true);
        setCalledServiceSettingsList(calledServiceSettingsList);
    }

    const closeCreateCalledDialog = () => {
        setCreateCalledDialogOpen(false);
    }

    return (
        <div className={classes.root}>
            <main className={classes.contentExternal}>
                <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, paddingInline: 0 }}>
                    <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                        <Grid item container>
                            {/* HEADER */}
                            <Header
                                intl={props.intl}
                                clientportal={clientportal}
                                calledservicesettings={clientportal.calledservicesettingsclientportals}
                                language={props.match.params.lang}
                                openCreateCalledDialog={openCreateCalledDialog}
                                logoimagesrc={logoimagesrc}
                                loading={loading}
                            />

                            <CommonSearchExternal
                                state={{ searchvalue }}
                                clientportal={clientportal}
                                loading={loading}
                                nameTextField={"searchvalue"}
                                handleChange={handleChange}
                                searchArticle={searchArticle}
                                mainImageSrc={mainimagesrc}
                            />

                            <Grid item xs={12} container justifyContent="center" mt={4}>
                                <CommonBackButtonExternal
                                    clientportal={clientportal}
                                    loading={loading}
                                    handleBack={handleBack}
                                    gridProps={{
                                        xs: 12,
                                        sm: 11,
                                        md: 10,
                                        lg: 8,
                                        xl: 7
                                    }}
                                />
                            </Grid>

                            {/* CONTEÚDO - Seção principal de artigos */}
                            <Grid item xs={12} container justifyContent="center" mt={4} mb={6}>
                                <CommonPaginateSkeleton
                                    loading={loading}
                                    marginInline='20vw'
                                    hasPaginate={false}
                                    simple
                                />

                                <NewsSectionMainContent
                                    articles={articles}
                                    sectionInfo={sectionInfo}
                                    clientportal={clientportal}
                                    props={props}
                                />
                            </Grid>
                        </Grid>

                        <Footer
                            intl={intl}
                            clientportal={clientportal}
                            setLoading={setLoading}
                            loading={loading}
                        />
                    </Grid>
                </Container>

                <CustomizedSnackbars
                    variant={notificationVariant}
                    message={notificationMessage}
                    isOpen={openNotification}
                    toClose={closeNotification}
                />

                <Modal
                    intl={intl}
                    title={<strong style={{ color: clientportal.defaulttextcolor }}>{clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                    open={createCalledDialogOpen}
                    onClose={closeCreateCalledDialog}
                    contentPadding={false}
                    maxWidth="md"
                    children={
                        <CalledServicesSettingsExternalFormList
                            calledServiceSettingsList={calledServiceSettingsList}
                            clientportal={clientportal}
                        />
                    }
                />
            </main>
        </div>
    );
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);

export default injectIntl(withStyles(Styles)(connect(null, mapDispatchToProps)(NewsSectionPage)));